import React, { Fragment } from "react";
import BaseComponent, { connect } from "@common/components/base.component";
import { Col, Row } from "react-bootstrap";
import Form from "@common/externos/components/validation/form.validation";
import DDadosItem from "@common/components/ddados/ddados.item";
import { ddados } from "../responderExigencia.ddados";
import autobind from "react-autobind";
import responderExigenciaSelector from "../store/responderExigencia.selectors";
import responderExigenciaActions from "../store/responderExigencia.actions";
import RedeSIMHeader from "../../redeSIM.header";
import GridResponderExigencia from "../container/responderExigencia.grid";
import GridDocumentoExigencia from "../container/responderExigencia.documento.grid";
import formActions from '@common/store/form/form.actions';
import Card from "@common/externos/components/card/card.externo";
import Typography from "@material-ui/core/Typography";
import focusHelper from '@common/helpers/focus.helper';
import { Tooltip, Button } from '@material-ui/core';

class Container extends BaseComponent {
  constructor(props) {
    super(props);
    autobind(this);
  }

  componentWillUnmount() {
    this.props.responderExigenciaActions.resetForm();
  }

  onCancel() {
    this.props.responderExigenciaActions.resetForm();
  }

  onSubmit(values) {
    this.props.responderExigenciaActions.postRespostaExigencia(values);
  }

  handleFocus() {
    const { responderExigencia } = this.props.responderExigenciaSelector;
    const { FormExigencia } = responderExigencia;
    const { Resposta } = FormExigencia;

    if(!Resposta) {
      focusHelper.focus("Resposta");
    }
  }

  render() {
    const { Campos, Titulo } = ddados;
    const { responderExigenciaSelector } = this.props;
    const { responderExigencia } = responderExigenciaSelector;
    const { ShowGridExigencia, FormExigencia, HeaderExigencia } = responderExigencia;

    return (
      <Fragment>
          <h2 className={"mb-4"}>{Titulo}</h2>
          <RedeSIMHeader selector={HeaderExigencia} />
          {ShowGridExigencia && <GridResponderExigencia />}
          {!ShowGridExigencia &&
            <Form onSubmitGeneric={this.onSubmit}>
              {form => (
                <Fragment>
                  <div style={{ marginBottom: "20px" }}>
                    <Card>
                    <Typography
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "#3f51b5",
                        paddingBottom: "10px"
                      }}
                    >
                      {"Exigência"}
                    </Typography>
                      <Row>
                        <Col lg={3}>
                          <DDadosItem
                            name="IdAnalise"
                            {...Campos.Analise}
                            state={FormExigencia}
                          />
                        </Col>
                        <Col lg={2}>
                          <DDadosItem
                            name="ExigenciaDocumento"
                            {...Campos.ExigenciaDocumento}
                            state={FormExigencia}
                          />
                        </Col>
                        <Col lg={7}>
                          <DDadosItem
                            name="TipoDocumento"
                            {...Campos.TipoDocumento}
                            state={FormExigencia}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={12}>
                          <DDadosItem
                            name="Exigencia"
                            {...Campos.Exigencia}
                            state={FormExigencia}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col lg={12}>
                          <DDadosItem
                            name="Motivo"
                            {...Campos.Motivo}
                            state={FormExigencia}
                          />
                        </Col>
                      </Row>
                    </Card>
                  </div>
                  <div style={{ marginBottom: "20px" }}>
                    <Card>
                    <Typography
                      style={{
                        fontSize: "18px",
                        fontWeight: "bold",
                        color: "#3f51b5",
                        paddingBottom: "10px"
                      }}
                    >
                      {"Resposta"}
                    </Typography>
                      <Row>
                        <Col lg={12}>
                          <DDadosItem
                            name="Resposta"
                            {...Campos.Resposta}
                            state={FormExigencia}
                            onBlur={(value) =>  this.props.responderExigenciaActions.setFormExigencia({ Resposta: value })}
                          />
                        </Col>
                      </Row>
                    </Card>
                  </div>
                  <div style={{ marginBottom: "20px" }}>
                    <Card>
                      <Typography
                        style={{
                          fontSize: "18px",
                          fontWeight: "bold",
                          color: "#3f51b5",
                          paddingBottom: "10px"
                        }}
                      >
                        {"Documentos e Anexos"}
                      </Typography>
                        <Row className={"mb-4"} style={{ marginTop: "10px" }}>
                          <Col>
                            <Tooltip title="Inserir Documento para enviar na resposta">
                              <Button
                                variant="contained"
                                color="primary"
                                onClick={() => this.props.responderExigenciaActions.toggleDocumentoModal()}
                              >
                                Documento
                                <i className={"fas fa-plus ml-2"} />
                              </Button>
                            </Tooltip>
                          </Col>
                        </Row>
                        <Row>
                          <Col lg={12}>
                            <GridDocumentoExigencia />
                          </Col>
                        </Row>
                    </Card>
                  </div>
                  <Row>
                    <Col lg={12} style={{ marginTop: "35px", textAlign: "right" }}>
                      <Button style={{ padding: "7px 21px", fontSize: " 0.9375rem" }} variant="outlined" color="primary" onClick={this.onCancel}>
                        <i className="fa fa-ban" />&nbsp;Cancelar
                      </Button>
                      &nbsp;
                      &nbsp;
                      <Button style={{ padding: "7px 21px", fontSize: " 0.9375rem" }} variant="contained" color="primary"
                      onClick={() => {
                          form.handleSubmit();
                          this.handleFocus()
                      }}>
                        <i className="fa fa-check" />&nbsp;Confirmar
                      </Button>
                    </Col>
                  </Row>
                </Fragment>
              )}
            </Form>
          }
      </Fragment>
    );
  }
}

export default connect({
  actions: {
    responderExigenciaActions,
    formActions
  },
  selectors: {
    responderExigenciaSelector
  }
})(Container);
